'use strict';
/**
 * Justifications module
 */
angular.module('reports', ['reports.components']);

angular.module('reports.components', []);
